import React, { useEffect, useState } from "react";
import AdminNav from "../../navigation/AdminNav";
import { useDispatch, useSelector } from 'react-redux';
import { getUsers, deleteUsers, updateUsers } from '../../actions/login';
import { Grid, CircularProgress, Button } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';

/**
 * This page presents the admin with a form to fill out to allow them to edit existing user accounts.
 * When the user infomration is submitted it will automatically show up on the screen which lets them know it submitted properly and be sent to the 
 * users collection in the database.
 * @returns the user edit form along with a list of all of the users and their information.
 */

function AdminManageUsers() {

    const [user, setUser] = useState({
        username: '', password: '', firstName: '', secondName: '', userType: '', choices: []
    });

    const [id, setID] = useState(null)

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUsers());
    }, [dispatch, user]);

    const submitHandler = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateUsers(id, user));
            alert("User Edited")
        }
        clearFields();
    }

    const handleProjectEdit = (user) => {
        const newUser = Object.assign({}, user)

        newUser.username = user.username;
        newUser.password = user.password;
        newUser.firstName = user.firstName;
        newUser.secondName = user.secondName;
        newUser.userType = user.userType;
        newUser.choices = user.choices;
        
        setID(user._id)
        setUser(newUser);
    }

    const clearFields = () => {
        setID(null);
        setUser({username: '', password: '', firstName: '', secondName: '', userType: '', choices: []});
    }

    let users = []
    const response = useSelector((state) => state.projects.data);
    if (response){
        users = Array.from(response);
    }

    return(
        <div>
            <AdminNav />
            <form id={id} onSubmit={submitHandler}>
                <h1>Manage Users Database</h1>
                <p>Below is information on all of the existing users</p>
                <label>
                    Username: 
                    <input type="text" name="username" label="Username" value={user ? user.username : ''} onChange={(e) => setUser({...user, username: e.target.value})}></input>
                </label>
                <label>
                    Password: 
                    <input type="text" name="password" label="Password" value={user ? user.password : ''} onChange={(e) => setUser({...user, password: e.target.value})}></input>
                </label>
                <label>
                   Firstname: 
                    <input type="text" name="firstname" label="Firstname" value={user ? user.firstName : ''} onChange={(e) => setUser({...user, firstName: e.target.value})}></input>
                </label>
                <label>
                    Secondname: 
                    <input type="text" name="secondname" label="Secondname" value={user ? user.secondName : ''} onChange={(e) => setUser({...user, secondName: e.target.value})}></input>
                </label>
                <label>
                    User Type: 
                    <input type="text" name="usertype" label="Usertype" value={user ? user.userType : ''} onChange={(e) => setUser({...user, userType: e.target.value})}></input>
                </label>
                <input className="submitButton" type="submit" name="submit" onClick={() => updateUsers(id, user)}></input>
                <Button onClick={clearFields}>
                    <ClearIcon/>
                    Clear
                </Button>
            </form>
            {!users.length ? <CircularProgress /> : (
                <Grid>
                    {users.map((user) => (
                        <Grid className="paper" key={user._id} item>
                            <p>{user.username}</p>
                            <p>{user.password}</p>
                            <p>{user.firstName}</p>
                            <p>{user.secondName}</p>
                            <p>{user.userType}</p>
                            <Button onClick={() => handleProjectEdit(user)}>
                                <EditIcon/>
                                Edit
                            </Button>
                            <Button onClick={() => dispatch(deleteUsers(user._id))}>
                                <DeleteIcon/>
                                Delete
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default AdminManageUsers